import { Country, StoredCreditCard, Product } from "./types";
import dateFormat from "dateformat";
import t from "./i18n";
import LanguageDetector from "./i18n/language-detector";

export const isDev = process.env.NODE_ENV === "development";

export function isEmail(value: string) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(value);
}
export function currency(value: number, currencyCode: string = "USD") {
	if (value === undefined || value === null) return `0.00 ${currencyCode}`;
	return `${value.toFixed(2)} ${currencyCode}`;
};
export function format(value: number | string | undefined, flexible: boolean = false) {
	if (value === undefined || value === null) return flexible ? "0" : "0.00";
	if (typeof (value) === "string") return value;
	let newValue = value.toFixed(2);
	if (flexible) {
		for (let i = newValue.length - 1; i >= 0; i--) {
			if (newValue[i] === "0") { newValue = newValue.substring(0, i); }
			else if (newValue[i] === ".") { newValue = newValue.substring(0, i); return newValue; }
			else return newValue;
		}
	}
	return newValue;
}
export function formatSummary(amount: number) {
	if (!amount) return 0;
	if (amount > 9999) {
		return Math.floor(amount);
	}
	const value = parseInt("" + amount * 100, 10) / 100;
	return value.toFixed(2);
}
export function formatDate(date: string | Date) {
	const lang = LanguageDetector.detect();
	if (lang == "es") {
		dateFormat.i18n = {
			dayNames: [
				'Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vier', 'Sáb',
				'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'
			],
			monthNames: [
				'Enero', 'Feb', 'Marzo', 'Abr', 'Mayo', 'Jun', 'Jul', 'Agosto', 'Sept', 'Oct', 'Nov', 'Dic',
				'de Enero', 'de Febrero', 'de Marzo', 'de Abril', 'de Mayo', 'de Junio', 'de Julio', 'de Agosto', 'de Septiembre', 'de Octubre', 'de Noviembre', 'de Diciembre'
			],
			timeNames: [
				'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
			]
		};
	}
	return dateFormat(date, "dd mmmm yyyy");
	// return date;
	// let dt = new Date(date);
	// return dateFormat(dt, "dd mmmm yyyy");
}
export function uuidv4() {
	if (window.crypto) {
		return ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
			(c ^ crypto.getRandomValues(new Uint8Array(1))![0] & 15 >> c / 4).toString(16)
		);
	}
	else {
		// tslint:disable-next-line:only-arrow-functions
		return ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/1|0/g, function () { return (0 | Math.random() * 16).toString(16) });
	}
}
export function getInvalidMobileNumberReason(country: Country | undefined, product: Product | undefined, mobileNumber: string): string | null {
	if (!mobileNumber) return t.topup("enter_mobile_number");
	if (mobileNumber.startsWith("0")) t.validations("mobile_number_invalid");
	if (country) {
		const lengths = country.localNumberLength.split(",").map(l => parseInt(l, 10));
		if (country.countryCode === "MX") {
			if (mobileNumber.length < 10) return t.validations("mobile_number_length", { length: `${lengths.join(" or ")}` });
			if (mobileNumber.startsWith("1") && mobileNumber.length !== 11) return t.validations("mobile_number_invalid")
			if (!mobileNumber.startsWith("1") && mobileNumber.length !== 10) return t.validations("mobile_number_invalid")
		}
		else if (country.countryCode === "HT") {
			if (product && product.name.toLowerCase().includes("natcom")) {
				const prefix: string[] = ["32", "33", "35", "40", "41", "42", "43"];
				if (!prefix.some(a => a === mobileNumber.substring(0, 2)) ||
					lengths.indexOf(mobileNumber.length) === -1) {
					return t.validations("mobile_number_invalid")
				}
			}
			else {
				if (lengths.indexOf(mobileNumber.length) > -1) return t.validations("mobile_number_length", { length: `${lengths.join(" or ")}` });
			}
		}
		else if (country.countryCode === "VE") {
			if (product && product.name.toLowerCase().includes("movistar")) {
				const prefix: string[] = ["414", "424"];
				if (!prefix.some(a => a === mobileNumber.substring(0, 3)) ||
					lengths.indexOf(mobileNumber.length) === -1) {
					return t.validations("mobile_number_invalid")
				}
			}
			else {
				if (lengths.indexOf(mobileNumber.length) > -1) return t.validations("mobile_number_length", { length: `${lengths.join(" or ")}` });
			}
		}
		else {
			if (lengths.indexOf(mobileNumber.length) > -1) return t.validations("mobile_number_length", { length: `${lengths.join(" or ")}` });
		}
	}
	return null;
}
export function isMobileNumberValid(country: Country | undefined, product: Product | undefined, mobileNumber: string) {
	if (!mobileNumber) return false;
	if (mobileNumber.startsWith("0")) return false;
	if (country) {
		const lengths = country.localNumberLength.split(",").map(l => parseInt(l, 10));
		if (country.countryCode === "MX") {
			if (mobileNumber.startsWith("1") && mobileNumber.length === 11) return true;
			if (!mobileNumber.startsWith("1") && mobileNumber.length === 10) return true;
		}
		else if (country.countryCode === "HT") {
			if (product && product.name.toLowerCase().includes("natcom")) {
				const prefix: string[] = ["22", "32", "33", "35", "40", "41", "42", "43", "55"];
				if (prefix.some(a => a === mobileNumber.substring(0, 2)) &&
					lengths.indexOf(mobileNumber.length) > -1) {
					return true;
				}
			}
			else {
				if (lengths.indexOf(mobileNumber.length) > -1) return true;
			}
		}
		else if (country.countryCode === "VE") {
			if (product && product.name.toLowerCase().includes("movistar")) {
				const prefix: string[] = ["414", "424"];
				if (prefix.some(a => a === mobileNumber.substring(0, 3)) &&
					lengths.indexOf(mobileNumber.length) > -1) {
					return true;
				}
			}
			else {
				if (lengths.indexOf(mobileNumber.length) > -1) return true;
			}
		}
		else {
			if (lengths.indexOf(mobileNumber.length) > -1) return true;
		}
	}
	return false;
}
export function validateStoredCard(storedCard: StoredCreditCard | undefined) {
	if (!storedCard) return t.validations("select_credit_card");
	if (!storedCard.cvvCode) return t.validations("cvv_required_validation");

	var dateObj = new Date();
	var month = dateObj.getUTCMonth() + 1; //months from 1-12
	var year = dateObj.getUTCFullYear();
	var blnExpired = false;
	var yy, mm;

	//    if (storedCard.expiryMonthyear.length == 5 || storedCard.expiryMonthyear.length == 7) {
	mm = parseInt((yy = storedCard.expiryMonthyear.substring(0, 2)));
	if (storedCard.expiryMonthyear.length > 5) {
		yy = parseInt(storedCard.expiryMonthyear.substring(storedCard.expiryMonthyear.length - 4));
	} else {
		yy = parseInt(storedCard.expiryMonthyear.substring(storedCard.expiryMonthyear.length - 2));
		year = parseInt(year.toString().substring(2));
	}

	if (yy < year || (yy === year && mm < month)) {
		blnExpired = true;
	} else {
		blnExpired = false;
	}

	if (blnExpired)
		return t.validations("month_validation");

	const creditCardType = storedCard.cardType.toLowerCase();
	if (creditCardType === "amex" && storedCard.cvvCode.trim().length !== 4) {
		return t.validations("cvv_validation");
	}
	if (creditCardType !== "amex" && storedCard.cvvCode.trim().length !== 3) {
		return t.validations("cvv_validation");
	}
	return undefined;
}

export function scrollWindow(to: number, duration: number) {
	const start = document.documentElement.scrollTop;
	const change = to - start;
	let currentTime = 0;
	const increment = 20;

	const animateScroll = () => {
		currentTime += increment;
		const val = easeInOutQuad(currentTime, start, change, duration);
		document.documentElement.scrollTop = val;
		if (currentTime < duration) {
			setTimeout(animateScroll, increment);
		}
	};
	animateScroll();
}

//t = current time
//b = start value
//c = change in value
//d = duration
const easeInOutQuad = (t1: any, b: any, c: any, d: any) => {
	t1 /= d / 2;
	if (t1 < 1) return c / 2 * t1 * t1 + b;
	t1--;
	return -c / 2 * (t1 * (t1 - 2) - 1) + b;
};